import { useLocation, Navigate } from 'react-router-dom';
import Error404 from './Error404';
import PrePurchaseInspection from '../Public/PrePurchaseInspection';
const CatchAllRouter = () => {
    const location = useLocation();
    const pathname = location.pathname;

    const match = pathname.match(/^\/pre-purchase-inspection-(.+)$/);
    if (match) {
        const city = match[1];
        return <PrePurchaseInspection city={city} />
    }

    return <Error404 />

}

export default CatchAllRouter;